import { Model } from 'pinia-orm';


export default class PostCategory extends Model {
  static entity = 'postCategory';

  static primaryKey = ['postId', 'categoryId'];

  static fields() {
    return {
      postId: this.attr(null),
      categoryId: this.attr(null),

    };
  }


}
